import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface ConcludeForgotPasswordRequestModel {
	readonly userId: string;
	readonly forgotPasswordCode: string;
	readonly newPassword: string;
}

export const useConcludeForgotPassword = () => {
	const http = useHTTP("None");

	const mutationFn: MutationFunction<HTTPResponse, ConcludeForgotPasswordRequestModel> = requestModel => {
		return http<undefined, ConcludeForgotPasswordRequestModel>({
			method: "POST",
			url: "/auth/forgot/conclude",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
